<template>
  <div
    class="tln-flex tln-rounded-lg tln-w-fit"
    :class="{'tln-p-2 tln-bg-purple-50 tln-text-black-800 tln-mr-2 tln-h-[45px] tln-w-[45px] tln-shrink-0 tln-items-center tln-justify-center': props.isCard}"
  >
    <TIcon
      :size="props.width"
      :icon="LIST_ICONS[props.msId]"
    />
  </div>
</template>
<script setup>
const props = defineProps({
  msId: {
    type: Number,
    required: true,
  },
  width: {
    type: String,
    default: '24px',
  },
  height: {
    type: String,
    default: '24px',
  },
  isCard: {
    type: Boolean,
    default: false,
  }
})

const LIST_ICONS = {
  1: 'material-symbols:category-outline', // KeyScoring => Psicométrica
  2: 'mdi:card-account-details-outline', // KeyJobs
  3: 'mdi:file-document-outline', // KeyCV => Carga Curricular manual
  4: 'material-symbols:videocam-outline', // KeyInterview
  5: 'mdi:email-outline', // KeyMailer
  6: 'mdi:cube', // KeyGames
  7: 'mdi:clipboard-check-outline', // KeyQuestions
  8: 'material-symbols:checklist', // KeyForm
}
</script>

